<template>
  <el-tabs ref='titleBadge' v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane name="first">  
      <span slot="label">  
      全部  
      <el-badge :value="allCount" class="item" type="primary"></el-badge> 
      </span>  
      <SchedulingBasisAllList v-if="activeName === 'first'" ref="first" @myevent="getSchedulingBasisViewModelsEntity"></SchedulingBasisAllList>
    </el-tab-pane> 
    <el-tab-pane name="second">  
      <span slot="label">  
      已排班  
      <el-badge :value="schedulingCount" class="item" type="primary"></el-badge> 
      </span>  
      <SchedulingBasisAlreadySchedulingList v-if="activeName === 'second'" ref="second" @myevent="getSchedulingBasisViewModelsEntity"></SchedulingBasisAlreadySchedulingList>
    </el-tab-pane> 
    <el-tab-pane name="third">  
      <span slot="label">  
      未排班  
      <el-badge :value="unSchedulingCount" class="item"></el-badge>  
      </span>  
      <SchedulingBasisUnSchedulingList v-if="activeName === 'third'" ref="third" @myevent="getSchedulingBasisViewModelsEntity"></SchedulingBasisUnSchedulingList>
    </el-tab-pane>  
  </el-tabs>
</template>
<script>
  import { getSchedulingBasisViewModels } from "../../api/api";
  import SchedulingBasisAllList from "./SchedulingBasisAll";
  import SchedulingBasisAlreadySchedulingList from "./SchedulingBasisAlreadyScheduling";
  import SchedulingBasisUnSchedulingList from "./SchedulingBasisUnScheduling";

  export default {
    components: {
      SchedulingBasisAllList,
      SchedulingBasisAlreadySchedulingList,
      SchedulingBasisUnSchedulingList
    },
    data() {
      return {
        activeName: 'first',
        allCount: 0,
        schedulingCount: 0,
        unSchedulingCount: 0
      };
    },
    methods: {
      handleClick(tab, event) {
        this.activeName = tab.name;
      },
      //获取首次排班线路人车绑定数量
      getSchedulingBasisViewModelsEntity() {
        let para = {
        };
        getSchedulingBasisViewModels(para).then(res => {
          this.allCount = res.data.AllCount;
          this.schedulingCount = res.data.SchedulingCount;
          this.unSchedulingCount = res.data.UnSchedulingCount;
        });
      }
    },
    mounted(){
      this.getSchedulingBasisViewModelsEntity();
    },
  };
</script>